import {useMutation} from "react-query";
import * as api from "../apiClient/userDeleteForm";

export const useGetUserDeleteAccount = (options) => {
  return useMutation((payload) => api.getUserDeleteAccount(payload), options);
};
